@use "../../../scss/settings/colors";

.checkbox_container {
  margin-top: 16px;
}

.modal_container {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); // Fondo oscuro semi-transparente
}

.submit-button {
  background-color: #ecdfff;
  &:hover{
      background-color: #b17dff;
      }
    }

.cancel-button {
  background-color: #fff;
  &:hover{
      background-color: #ededed;
    }
  }

// ---------- Responsive ----------
.modal_container {
  box-sizing: border-box;
  padding: 16px;
  overflow-y: auto;
}
